import { get } from "./base";

export async function getCourseList(params) {
    let respObj = await get("/api/course/getPageList", params);
    if (respObj != false) {
        // 处理接口数据
        let filters = null;
        if (respObj.trainCycle != null) {
            filters = [
                {
                    title: "培训周期", // 分组标题
                    list: respObj.trainCycle, // 分组内容
                },
                // 参照上方注释，以此类推
                { title: "学段", list: respObj.period },
                { title: "课程费用", list: respObj.money },
                { title: "课程类型", list: respObj.type },
            ];
        }
        return {
            sideFilters: filters,
            list: respObj.list,
            topFilters: respObj.hillock,
            total: respObj.total
        };
    }
    return {};
}